"use client";
import { createContext, useContext, useEffect, useState } from "react";
import axiosAuth from "../utils/axiosAuth";

type UserType = { _id: string; username: string,  isAdmin?: boolean; role?: string; } | null;

const UserContext = createContext<UserType>(null);

export function UserProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<UserType>(null);
  const [loading, setLoading] = useState(true);

   useEffect(() => {
    // Only runs on client
    const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    axiosAuth.get("/api/auth/me", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  // Prevent hydration mismatch by not rendering children until loading is done
  if (loading) return null;

  return (
    <UserContext.Provider value={user}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}